import React, { useState } from 'react';
import swal from 'sweetalert';
import { vanSubsNGeniusPaymentGateway } from '../../actions/VanSubscription';



const VanSubsNGenius = ({paymentConfig,userDetail,subsFeeDetail}) => {
    const [loading,setLoading] = useState(false)
    const {id} = userDetail !==undefined && userDetail
    const [formActionUrl,setFormActionUrl] = useState();

    const checkout = async () => {
        setLoading(true)
        // const successUrl = `${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/success`;
        // const failureUrl = `${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/failure`;
        // const data = {
        //     student_id: id,
        //     amount:subsFeeDetail?.amount,
        //     gateway_id: paymentConfig.id,
        //     months:subsFeeDetail?.planType,
        //     subscriptions_id:subsFeeDetail?.subscriptions_id,
        //     success_url:successUrl,
        //     failure_url:failureUrl,
        //   }

          const data = {
            student_id: id,
            amount:subsFeeDetail?.amount,
            gateway_id: paymentConfig.id,
            id:subsFeeDetail?.id,
            fee_type:subsFeeDetail?.pay_type,
            subscription_type:subsFeeDetail?.subscription_type,
            subscriptions_id:subsFeeDetail?.subscriptions_id,
            success_url:`${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/success`,
            failure_url:`${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/failure`,
          }
          
        try {
          const res = await vanSubsNGeniusPaymentGateway(data)
          if (res.status) {
              setLoading(true)
              window.location.href=res?.payment_url
          }

          else {
              swal(`Payment Failed! We couldn't process your payment. Please Try Again!`, '', 'error');
              setLoading(false)
          }
          
        } catch (error) {
            swal('Something went wrong','','error')
            console.log('n-genius error...',error)
            setLoading(false)
        }
        
            
    }
   
    return (
        <React.Fragment>
            <div>
            {loading ? <button type="submit" disabled className="banktransfer_btn">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Processing ...</button> : 
               <button onClick={checkout} className='banktransfer_btn'>N-Genius</button>
            }
                
                {/* <form ref={formRef}
                    method="POST"
                    name="redirect"
                    action={formActionUrl !==undefined ? formActionUrl : ''}
                    >
                    <input type="hidden" id="encRequest" name="enc_request" value={encRequestRes} />
                    <input type="hidden" name="access_code" id="access_code" value={accessCode} />
                </form> */}
            </div>

        </React.Fragment>
    )
}

export default VanSubsNGenius